(ns manage.adset-decision-tree-page.view.predicate-editor.validation
  (:require [malli.core :as m]
            [malli.util :as mu]
            [manage.adset-decision-tree-page.view.predicate-editor.converter
             :refer [get-property-operators operator-lookup]]))

(defn build-operand-validator [{property-type :type :keys [minimum maximum]}]
  (case property-type
    "integer" [:and
               [:string {:min 1 :error/message ""}]
               [:fn {:error/message
                     (cond-> "should be a number"
                       minimum (str " greater than " minimum)
                       (and minimum maximum) (str " and")
                       maximum (str " less than " maximum))}
                (fn [value]
                  (when-let [number (parse-long value)]
                    (and (or (not minimum) (<= minimum number))
                         (or (not maximum) (<= number maximum)))))]]
    "timestamp" [:and some? [:fn #(.isValid ^js %)]]
    "time" [:and some? [:fn #(.isValid ^js %)]]
    [:not {:error/message ""} empty?]))

(defn build-operands-schema-for-operator [{:keys [value-type-modifier]} property]
  (let [property-type (:type property)
        operand-validator (build-operand-validator property)]
    (if (or (= value-type-modifier :nil) (= property-type "bool"))
      [:or nil? [:map [:value true?]]]
      (case value-type-modifier
        :range [:map [:start operand-validator] [:end operand-validator]]
        [:map [:value operand-validator]]))))

(def base-predicate-schema
  [:map {:error/message ""}
   [:trigger [:string {:min 1 :error/message ""}]]
   [:operator [:string {:min 1 :error/message ""}]]])

(defn build-predicate-schema-for-property [property]
  (into
   [:multi {:dispatch :operator}
    [::m/default base-predicate-schema]]
   (for [{operator-key :key} (get-property-operators property)
         :let [{:keys [value-type-modifier] :as operator} (get operator-lookup operator-key)
               operands-schema (build-operands-schema-for-operator operator property)
               optional-operands (or (= value-type-modifier :nil)
                                     (= (:type property) "bool"))]]
     [(name operator-key) (mu/assoc base-predicate-schema
                                    [:operands {:optional optional-operands}]
                                    operands-schema)])))

(defn build-malli-schema-from-schema-output [schema-output]
  (into [:multi {:dispatch :trigger :error/message ""}
         [::m/default base-predicate-schema]]
        (for [[trigger-key property] schema-output]
          [(name trigger-key) (build-predicate-schema-for-property property)])))

(defn get-schema-for-form [{:keys [output]}]
  [:map-of :int (build-malli-schema-from-schema-output output)])
